import { RouteConfig } from "vue-router";

export const users: RouteConfig[] = [
  {
    // ユーザー管理
    path: "users",
    component: () => import("@/pages/Users/_Tab.vue"),
    children: [
      {
        path: "",
        name: "users-list",
        component: () => import("@/pages/Users/UsersList.vue")
      },
      {
        path: "new",
        name: "users-new",
        component: () => import("@/pages/Users/UsersNew.vue")
      }
    ]
  },
  {
    // ユーザー詳細 (全社)
    path: "users/:userId",
    component: () => import("@/pages/User/_Tab.vue"),
    children: [
      {
        path: "",
        name: "user-details",
        component: () => import("@/pages/User/UserDetails.vue")
      }
    ]
  }
];
